import $ from 'jquery';
import pageScripts from './pages';

import 'what-input';

require('slick-carousel/slick/slick');


$( document ).ready( function () {
	//Require all components here.
	require( './common/foundation' );
	require ('./components/brands-block');
	require ('./components/news-block');

	document.body.className.replace(/-/g, '_').split(/\s+/).forEach(cls => {
		pageScripts[cls] && pageScripts[cls]();
	});
} );
